import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
    SortingState, SelectionState, FilteringState, PagingState, RowDetailState,
    IntegratedFiltering, IntegratedPaging, IntegratedSorting, IntegratedSelection,
} from '@devexpress/dx-react-grid';
import {
    Grid,
    Table,
    TableHeaderRow, TableFilterRow, TableSelection, TableColumnResizing,
    PagingPanel,
    Toolbar,
} from '@devexpress/dx-react-grid-material-ui';

import {
    DateTimeTypeProvider,
    FilterCellComponent,
    FilterIcon,
    filtersMessages,
    filteringColumnExtensions
} from '../shared/custom-grid-items/DataFormatters';

import CustomActionsState from '../shared/custom-grid-items/CustomActionsState';
import CustomActions from '../shared/custom-grid-items/CustomActions';

// Material components
import {
    Paper
} from '@material-ui/core';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    detailContainer: {
        margin: '10px',
    },
    paperMain: {
        padding: '10px',
        textAlign: 'right',
        minHeight: "450px",
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center'
    },
});



class GridLogAccessiCmp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            columns: [
                { name: 'ID', title: 'ID' },
                { name: 'SerialNumber', title: 'S/N' },
                { name: 'ProductKey', title: 'Product Key' },
                { name: 'IP', title: 'IP' },
                { name: 'MAC', title: 'MAC' },
                { name: 'DataAccesso', title: 'Data Accesso' },
                { name: 'Major', title: 'Major' },
                { name: 'Minor', title: 'Minor' },
                { name: 'Build', title: 'Build' },
                { name: 'SP', title: 'SP' },
                { name: 'Patch', title: 'Patch' },
                { name: 'CodiceUtente', title: 'Codice Utente' },
            ]
        };

        this.onSelectionChange = this.onSelectionChange.bind(this);

    }

    componentDidUpdate(propsPrecedenti) {
        if (this.props.selectedRowIndex !== propsPrecedenti.selectedRowIndex) {
            if (this.props.selectedRowIndex === -1)
                this.props.setSelectedLogAccesso({});
            else
                this.props.setSelectedLogAccesso(this.props.log_accessi[this.props.selectedRowIndex]);
        }
    }

    onSelectionChange(newSelection) {

        this.props.handleRowSelection(newSelection);

    }

    render() {
        const { classes, getLogAccessi, resetFilters, codiceUtente } = this.props;

        return (
            <Paper className={classes.paperMain}>
                <Grid
                    rows={this.props.log_accessi}
                    columns={this.state.columns}
                >
                    <DateTimeTypeProvider for={['DataAccesso']} />

                    <FilteringState
                        filters={this.props.filters}
                        onFiltersChange={filters => this.props.onFiltersChange(filters)}
                    />

                    <SortingState
                        sorting={this.props.sorting}
                        onSortingChange={sorting => this.props.onSortingChange(sorting)}
                    />

                    <PagingState
                        currentPage={this.props.currentPage}
                        onCurrentPageChange={currentPage => this.props.onCurrentPageChange(currentPage)}
                        pageSize={this.props.pageSize}
                        onPageSizeChange={pageSize => this.props.onPageSizeChange(pageSize)}
                    />

                    <SelectionState
                        selection={this.props.selection}
                        onSelectionChange={this.onSelectionChange}
                    />

                    <RowDetailState
                        expandedRowIds={this.props.expandedRowIds}
                        onExpandedRowIdsChange={expandedRowIds => this.props.handleExpandedRow(expandedRowIds)}
                    />

                    <IntegratedFiltering columnExtensions={filteringColumnExtensions} />
                    <IntegratedSorting />
                    <IntegratedPaging />
                    <IntegratedSelection />

                    <Table />

                    <TableColumnResizing
                        columnWidths={this.props.columnWidths}
                        onColumnWidthsChange={widths => this.props.onColumnWidthsChange(widths)}
                    />

                    <TableSelection
                        highlightRow
                        selectByRowClick
                        showSelectionColumn={false}
                    />

                    <TableFilterRow cellComponent={FilterCellComponent}
                        showFilterSelector
                        iconComponent={FilterIcon}
                        messages={filtersMessages}
                    />

                    <TableHeaderRow showSortingControls />
                    <CustomActionsState
                        onRefreshClick={() => getLogAccessi(codiceUtente)}
                        onResetClick={() => resetFilters()}
                    />

                    <Toolbar />
                    <CustomActions />


                    <PagingPanel pageSizes={this.props.pageSizes} />

                </Grid>
            </Paper>
        );

    }
}

GridLogAccessiCmp.propTypes = {
    getLogAccessi: PropTypes.func.isRequired,
    getLogAccessiRequestStatus: PropTypes.string.isRequired,
    log_accessi: PropTypes.arrayOf(PropTypes.object).isRequired,

    setSelectedLogAccesso: PropTypes.func.isRequired,

    resetFilters: PropTypes.func.isRequired,
};

export default withStyles(styles)(GridLogAccessiCmp);